import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PasswordRequestComponent from './password-request.component';

let PasswordRequestModule = angular
  .module('PasswordRequest', [
    uiRouter
  ])
  .component('passwordRequest', PasswordRequestComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('passwordRequest', {
      url: '/password-request',
      views: {
        'menu': "",
        'content': {
          component: 'passwordRequest'
        }
      }
    })
  })
  .name;

export default PasswordRequestModule;



// WEBPACK FOOTER //
// ./src/app/pages/password-request/password-request.module.js